import { useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { formatNumber } from '@boatnav/core';
import { useWeatherStore, WEATHER_DIM_AGE_MS, WEATHER_HIDE_AGE_MS } from './weatherStore.js';
import { useConditionsSourcesStore } from './sourcesStore.js';
import { ageMs } from './age.js';
import { ConditionsSheet } from './ConditionsSheet.js';
import { msg } from '../../lib/messages.js';
import './conditions.css';

/** Wind chip on Navigate, next to the GPS chip (spec 11) — tap opens the
 *  "Vær og vannstand" sheet. Hidden entirely when weather isn't configured
 *  server-side, or there is no reading to show yet, or the last reading is
 *  older than the hide threshold (dishonest to keep showing it as live). */
export function WindChip(): JSX.Element | null {
  const [open, setOpen] = useState(false);
  const available = useConditionsSourcesStore((s) => s.weatherAvailable);
  const data = useWeatherStore((s) => s.data);
  const fetchedAt = useWeatherStore((s) => s.fetchedAt);

  const hour = data?.hours[0];
  const age = ageMs(fetchedAt);
  const hidden = !available || !hour || (age != null && age > WEATHER_HIDE_AGE_MS);

  if (hidden) return null;
  const stale = age != null && age > WEATHER_DIM_AGE_MS;

  return (
    <>
      <button
        type="button"
        className={`wind-chip${stale ? ' wind-chip--stale' : ''}`}
        onClick={() => setOpen(true)}
        aria-label={msg.conditions.title}
      >
        <ArrowUp
          size={14}
          className="wind-chip__arrow"
          style={{ transform: `rotate(${hour!.windFromDeg + 180}deg)` }}
          aria-hidden="true"
        />
        <span className="numeral">
          {formatNumber(hour!.windMs, 0)}
          {hour!.windGustMs != null ? ` (${formatNumber(hour!.windGustMs, 0)})` : ''} m/s
        </span>
      </button>
      {open && <ConditionsSheet onClose={() => setOpen(false)} />}
    </>
  );
}
